import { render, staticRenderFns } from "./settlementStatement.vue?vue&type=template&id=bb0560e2"
import script from "./settlementStatement.vue?vue&type=script&lang=js"
export * from "./settlementStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports